export class PurchaseOrderLine {
  uid: string;
  purchaseOrderUid: string;
  productUid: string;
  productName: string;
  quantityOrdered: number;
  quantityReceived?: number;
  unitPrice: number; 
  price: number;
}

export class PurchaseOrder {
  id: number;
  uid: string;
  orderNumber: string;
  supplierUid: string;
  supplierName?: string;
  orderDate: Date;
  status: number;
  lines: PurchaseOrderLine[];
}